var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-icon-card"},[(_vm.$slots.icon)?_c('div',{staticClass:"ui-icon-card__icon"},[_vm._t("icon")],2):_vm._e(),_c('div',{staticClass:"ui-icon-card__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }